/*
 * @author: yanhoup
 * @description: 导出按钮
 */
import $i18n from 'panda-i18n';
import React from 'react';
import { Button, Dialog } from '@fpxfd/next';
import { ButtonProps } from '@fpxfd/next/types/button';
import { useRequest, useSetState } from 'ahooks';
import { request } from 'ice';

interface ExportButtonProps extends ButtonProps {
  code: String;
  reqObj: Object;
  datas?: any;
  beforeExport?: () => boolean;
}

const OfflineExport = ({ code, reqObj, children, datas, beforeExport, ...lastProps }: ExportButtonProps) => {
  const [state, setState] = useSetState({
    loading: false,
  });

  // 点击离线导出
  const sendExport = () => {
    if (beforeExport && !beforeExport()) {
      return;
    }
    setState({ loading: true });
    request
      .post('/portal/exportTask/offlineExport', { exportType: code, reqObj, ...datas })
      .then(
        (res) => {
          Dialog.confirm({
            messageProps: {
              type: 'success',
            },
            title: $i18n.get({ id: '31255238623236096.CNTM', dm: '导出' }),
            content: $i18n.get({
              id: 'TheExportTaskIsAlreadyInProgress_485352460',
              dm: '导出任务已在进行中，请在【数据】--【导出列表】查看导出进度',
            }),
            onOk: () => {
              window.open('/service/rowexportlist');
            },
            onCancel: () => console.log('cancel'),
            cancelProps: { children: $i18n.get({ id: 'Close.four_px', dm: '关闭' }) },
            okProps: { children: $i18n.get({ id: 'GoToCheck', dm: '前往查看' }) },
          });
        },
        (error) => {
          setState({ loading: false });
        },
      )
      .finally(() => {
        setState({ loading: false });
      });
  };
  return (
    <Button
      type="primary"
      onClick={(e) => {
        sendExport();
      }}
      size="medium"
      loading={state.loading}
      {...lastProps}
    >
      {children || $i18n.get({ id: 'OfflineExport', dm: '离线导出' })}
    </Button>
  );
};

export default OfflineExport;
